import { Link } from "react-router-dom";
import posts from "../posts.json";

export default function Blog() {
  const [featured, ...rest] = posts;
  const latest = posts.slice(0, 3);

  return (
      <section
        className="relative text-white min-h-screen py-20 px-6 mt-20 max-w-7xl mx-auto"
      >
        <div className="text-center mb-16 z-10 relative">
          <h1 className="text-[3rem] md:text-[4rem] mb-4">
            Ever wonder what we're up to?
          </h1>
          <p className="text-lg text-gray-400">
            Stay up to date with insider info and development updates with our blog.
          </p>
        </div>

        {featured && (
          <section className="mb-24 z-10 relative">
            <Link
              to={`/blog/${featured.slug}`}
              className="block border-card hover:border-card/50 hover:bg-card/50 hover:opacity-75 border-2 transition-all shadow-xl text-left"
            >
              <div className="flex flex-col md:flex-row">
                <div className="md:w-1/2">
                  <img
                    src={featured.image}
                    alt={featured.title}
                    className="w-full h-64 md:h-full object-cover"
                  />
                </div>

                {/* Text container */}
                <div className="p-8 md:w-1/2 flex flex-col">
                  {/* Title & description */}
                  <div className="flex-grow">
                    <h3 className="text-3xl font-bold mb-4">{featured.title}</h3>
                  </div>
                  
                  <div className="flex-grow">
                    <p className="mb-6 text-lg text-gray-300">{featured.description}</p>
                  </div>

                  {/* Metadata pinned at bottom */}
                  <div className="flex justify-between items-center text-gray-400 mt-auto">
                    <span className="flex-1">{featured.author}</span>
                    <span className="flex-1 text-center">{featured.readTime}</span>
                    <span className="flex-1 text-right">{featured.date}</span>
                  </div>
                </div>
              </div>
            </Link>
          </section>
        )}


        {posts.length > 0 && (
          <section className="mb-24 z-10 relative">
            <h2 className="text-2xl font-bold mb-6">Latest Entries</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
              {latest.map(({ slug, title, description, author, readTime, date, image }) => (
                <Link
                  to={`/blog/${slug}`}
                  key={slug}
                  className="border-card hover:border-card/50 hover:bg-card/50 border-2 shadow-lg text-left flex flex-col justify-between"
                >
                  <img
                    src={image}
                    alt={title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-6">
                    <h3 className="text-xl font-semibold mb-5">{title}</h3>
                    <p className="mb-4 flex-grow text-gray-300">{description}</p>
                    <div className="flex justify-between items-center text-gray-400">
                      <span className="flex-1">{author}</span>
                      <span className="flex-1 text-center">{readTime}</span>
                      <span className="flex-1 text-right">{date}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        )}

        {posts.length > 0 && (
          <section className="z-10 relative">
            <h2 className="text-2xl font-bold mb-6">All Articles</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
              {posts.map(({ slug, title, description, author, readTime, date, image }) => (
                 <Link
                  to={`/blog/${slug}`}
                  key={slug}
                  className="border-card hover:border-card/50 hover:bg-card/50 border-2 shadow-lg text-left flex flex-col justify-between"
                  >
                    <img
                      src={image}
                      alt={title}
                      className="w-full h-48 object-cover"
                    />
                    <div className="p-6">
                      <h3 className="text-xl font-semibold mb-5">{title}</h3>
                      <p className="mb-4 flex-grow text-gray-300">{description}</p>
                      <div className="flex justify-between items-center text-gray-400">
                        <span className="flex-1">{author}</span>
                        <span className="flex-1 text-center">{readTime}</span>
                        <span className="flex-1 text-right">{date}</span>
                      </div>
                    </div>
                  </Link>
              ))}
            </div>
          </section>
        )}
      </section>
  );
}